import { Pipe, PipeTransform } from '@angular/core';
interface DateExpireStatusResult {
  status: string;
  className: string;
}

@Pipe({
  name: 'dateExpire',
})
export class DateExpirePipe implements PipeTransform {
  transform(dateString: string | undefined): DateExpireStatusResult {
    let result: DateExpireStatusResult = {
      status: '',
      className: '',
    };

    if (!dateString) {
      result.status = 'Not Available';
      result.className = 'not-available';
      return result;
    }

    const expiryDate = new Date(dateString);
    const today = new Date();
    const expiryDateTime = expiryDate.getTime();
    const todayTime = today.getTime();
    const sixtyDaysInMillis = 60 * 24 * 60 * 60 * 1000; // 60 days in milliseconds

    if (expiryDateTime - todayTime <= 0) {
      result.status = 'Expired';
      result.className = 'renewal-expired';
    } else if (expiryDateTime - todayTime <= sixtyDaysInMillis) {
      result.status = 'Expire Soon';
      result.className = 'expire-soon';
    } else {
      result.status = 'Active';
      result.className = 'active-date';
    }

    return result;
  }
}